import { Button, Text as ChakraText, Link } from '@chakra-ui/react';
import { Text } from '../../../../ui-components';

export const StrongText = (chunks: React.ReactNode[]): React.ReactElement => (
    <ChakraText as="span" fontWeight={600}>
        {chunks}
    </ChakraText>
);

export const TelLink = (chunks: React.ReactNode[]): React.ReactElement => (
    <a href="tel:1-317-559-2041">
        <Text>{chunks}</Text>
    </a>
);

type CheckBalanceModalLinkProps = {
    onClick: () => void;
    'data-testid': string;
};

export const CheckBalanceModalLink = (
    chunks: React.ReactNode[],
    props: CheckBalanceModalLinkProps,
): React.ReactElement => (
    <Button
        color="slt-pepper.1000"
        variant="newtext-button-no-hover"
        fontWeight={400}
        {...props}
        minWidth="initial"
    >
        <Text type="link" style="bold">
            {chunks}
        </Text>
    </Button>
);

type GiftCardLinkProps = {
    href: string;
    noUnderline?: boolean;
};

export const GiftCardLink = (
    chunks: React.ReactNode[],
    { href, noUnderline }: GiftCardLinkProps,
): React.ReactElement => (
    <Link
        href={href}
        textDecoration={noUnderline ? 'none' : 'underline'}
        fontWeight={500}
        textUnderlineOffset="4px"
    >
        {chunks}
    </Link>
);
